module.exports = __webpack_public_path__ + "static/img/A6233_.2b8382a1.png";